import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { CalendarIcon } from "lucide-react";
import { format } from "date-fns";
export var StepDate = function (_a) {
    var formData = _a.formData, availableSlots = _a.availableSlots, onUpdate = _a.onUpdate, onNext = _a.onNext;
    var _b = useState(false), isPopoverOpen = _b[0], setIsPopoverOpen = _b[1];
    var handleDateSelect = function (selectedDate) {
        if (selectedDate) {
            onUpdate({ appointmentDate: selectedDate, appointmentTime: "" });
            setIsPopoverOpen(false);
            onNext();
        }
    };
    // Get available dates from slots
    var availableDates = availableSlots.map(function (slot) { return new Date(slot.date); });
    // Create a matcher function for react-day-picker
    var isDateAvailable = function (date) {
        return availableDates.some(function (availableDate) {
            return availableDate.getFullYear() === date.getFullYear() &&
                availableDate.getMonth() === date.getMonth() &&
                availableDate.getDate() === date.getDate();
        });
    };
    // Disable dates that are not in the available slots
    var disabledDays = function (date) { return !isDateAvailable(date); };
    return (React.createElement("div", { className: "flex flex-col items-center" },
        React.createElement("h3", { className: "text-xl font-semibold mb-6 text-center" }, "Select a date for your tour"),
        React.createElement(Popover, { open: isPopoverOpen, onOpenChange: setIsPopoverOpen },
            React.createElement(PopoverTrigger, { asChild: true },
                React.createElement(Button, { variant: "outline", className: "w-[280px] justify-start text-left font-normal text-base py-6" },
                    React.createElement(CalendarIcon, { className: "mr-2 h-4 w-4" }),
                    formData.appointmentDate ? (format(formData.appointmentDate, "PPP")) : (React.createElement("span", null, "Pick a date")))),
            React.createElement(PopoverContent, { className: "w-auto p-0", align: "center" },
                React.createElement(Calendar, { mode: "single", selected: formData.appointmentDate, onSelect: handleDateSelect, disabled: disabledDays, initialFocus: true }))),
        React.createElement("p", { className: "text-sm text-muted-foreground mt-4" }, "Select from available dates to continue")));
};
